import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { LldStages } from "types/lldJudge"

interface Feedback {
  feedbacks: {
    clarifying_requirements?: string
    class_diagram?: string
    schema_design?: string
  }
  hireStatus: string
}

interface LLDJudgeState {
  currentStage: LldStages
  problemDescription: string
  isUserSpeaking: boolean
  feedback: Feedback | null
  botResponse: any
  isSocketLoading: boolean
  response: string
  wordCurrentIndex: number
  isGeneratingResponse: boolean
  isSocketDisconnected: boolean
  conversations: null
  startSessionAlreadyInitiated: boolean
}

const initialState: LLDJudgeState = {
  currentStage: LldStages.TestInstructions,
  problemDescription: "",
  feedback: null,
  isUserSpeaking: false,
  isSocketLoading: true,
  botResponse: null,
  response: "",
  wordCurrentIndex: 0,
  isGeneratingResponse: false,
  isSocketDisconnected: false,
  conversations: null,
  startSessionAlreadyInitiated: false,
}

const LLDJudgeSlice = createSlice({
  name: "lld-judge",
  initialState,
  reducers: {
    updateCurrentStage: (state, action: PayloadAction<LldStages>) => {
      state.currentStage = action.payload
    },
    setProblemDescription: (state, action: PayloadAction<string>) => {
      state.problemDescription = action.payload
    },
    setFeedback: (state, action: PayloadAction<Feedback>) => {
      state.feedback = action.payload
    },
    setIsUserSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isUserSpeaking = action.payload
    },
    setBotResponse: (state, action) => {
      state.botResponse = action.payload
    },
    setIsSocketLoading: (state, action) => {
      state.isSocketLoading = action.payload
    },
    appendResponseText: (state, action) => ({
      ...state,
      response: state.response + " " + action.payload,
    }),
    setClearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setLldCurrentWordIndex: (state, action) => {
      state.wordCurrentIndex = action.payload
    },
    setIsGeneratingResponse: (state, action) => {
      state.isGeneratingResponse = action.payload
    },
    setIsSocketDisconnected: (state, action) => {
      state.isSocketDisconnected = action.payload
    },
    setConversations: (state, action) => {
      state.conversations = action.payload
    },
    setStartSessionAlreadyInitiated: (state, action) => {
      state.startSessionAlreadyInitiated = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  updateCurrentStage,
  setFeedback,
  setIsUserSpeaking,
  setProblemDescription,
  setBotResponse,
  setIsSocketLoading,
  appendResponseText,
  setClearResponse,
  setLldCurrentWordIndex,
  setIsGeneratingResponse,
  setIsSocketDisconnected,
  setConversations,
  setStartSessionAlreadyInitiated,
  resetState,
} = LLDJudgeSlice.actions
export default LLDJudgeSlice.reducer
